import { Controller } from '@hotwired/stimulus';
import Choices from 'choices.js';

export default class extends Controller {
  static targets = ['input'];

  static values = {
    hasCustomStyles: Boolean,
  };

  connect() {
    const config = {
      allowHTML: true,
      duplicateItemsAllowed: true,
      removeItemButton: true,
      searchEnabled: true,
      searchChoices: true,
      searchFields: ['label'],
      searchPlaceholderValue: 'Start typing to search...',
      searchResultLimit: 50,
    };

    // Apply custom template only if custom styles are needed
    if (this.hasCustomStylesValue) {
      // Extract data-color from <option> and turn into setChoices payload
      const choicesData = Array.from(this.inputTarget.options).reduce((acc, option) => {
        acc[option.value] = {
          value: option.value,
          label: option.label,
          selected: option.selected,
          data: {
            color: option.dataset.color || '',
          },
        };
        return acc;
      }, {});

      config.callbackOnCreateTemplates = (strToEl) => ({
        item: (_classNames, data) => {
          const colorClass = choicesData[data.value]?.data?.color || '';

          return strToEl(`
              <div
                class="choices__item choices__item--selectable"
                data-item
                data-id="${data.id}"
                data-value="${data.value}"
                data-color="${colorClass}"
                style="--tag-color: ${colorClass}"
                ${data.active ? 'aria-selected="true"' : ''}
                ${data.disabled ? 'aria-disabled="true"' : ''}
                role="option"
                ${data.deletable ? 'data-deletable' : ''}
              >
                <span class="choices__item-text">${data.label}</span>
                <button
                  type="button"
                  class="choices__button"
                  data-button
                  aria-label="Remove item"
                >×</button>
              </div>
            `);
        },
      });

      // Replace the <select> with Choices and populate from parsed <option> tags
      this.choices = new Choices(this.inputTarget, config);
      this.choices.setChoices(Object.values(choicesData), 'value', 'label', true);
    } else {
      this.choices = new Choices(this.inputTarget, config);
    }
  }
}
